<template>
  <div id="app">
    <AppHeader v-if="!authLayout" />
    <AppSidebar v-if="!authLayout" />
    <div :class="{ app__wrapper: !authLayout }">
      <transition name="fade">
        <router-view></router-view>
      </transition>
      <UiSpinnerLoading v-if="loading" />
    </div>
  </div>
</template>

<script src="./main.js?v=1.4"></script>

<script>
import { mapGetters } from 'vuex'
import AppHeader from './Header.vue'
import AppSidebar from './Sidebar'
import { AuthService } from '../services/auth.service'
import { getItemByLocalStorage, setLocalStorage } from '@/utils/localStorage'
import localStorageKey from '@/constants/localStorageKey'
import UiSpinnerLoading from '@/components/progress-loaders/UiSpinnerLoading'

export default {
  name: 'AppLayout',
  components: {
    AppHeader,
    AppSidebar,
    UiSpinnerLoading
  },
  computed: {
    ...mapGetters({
      loading: 'common/loading'
    }),
    authLayout () {
      return this.$route.meta.authLayout
    }
  },
  created () {
    const currentUser = getItemByLocalStorage(localStorageKey.CURRENT_USER)
    if (currentUser.username === 'kidzaniahn') {
      setLocalStorage('reloadCheck', true)
      const isRefresed = getItemByLocalStorage(localStorageKey.REFREESHED)
      if (!isRefresed) {
        setLocalStorage(localStorageKey.REFREESHED, true)
        window.location.reload()
      }
    }
    const today = new Date()
    const month = today.getMonth() + 1
    const date = today.getDate()
    const isInvalidTimeKidz = month > 2 && currentUser.username === 'kidzaniahn'
    if (isInvalidTimeKidz && false) {
      AuthService.makeLogout()
    }
  }
}
</script>

<style lang="scss" scoped>
.app__wrapper {
  padding: 100px 10px 0 40px;
}
@include media_tablet {
  .app__wrapper {
    padding: 70px 10px 0 10px;
  }
}
</style>
